module.exports = __webpack_public_path__ + "img/thirdCustom.fe3c2f20.svg";